//@flow
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import React from 'react';
import axios from "axios";
import { useTranslation } from "react-i18next";
import IconButton from "@mui/material/IconButton";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { enqueueSnackbar } from "notistack";
import { handleAxiosErrors } from "../../../../helpers/errorHandling"
import useUserData from "../../../../hooks/user/useUserData";
import { REPORTS } from "../../../../modules/reports/locales/namespaces";

type Props = {
	url: string,
	data: Object
}

const ExportExcelFromUrl = (props: Props) => {
	const { url, data } = props;
	const { t } = useTranslation(REPORTS);
	const {token} = useUserData()
	
	const handleExportExcel = () => {
		axios({
			method: 'post',
			data: data,
			url: url,
			responseType: 'blob',
			headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
		})
		.then(response => {
			const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
			const link = document.createElement('a');
			link.href = window.URL.createObjectURL(blob);
			link.download = 'exported_data.xlsx';
			
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			window.URL.revokeObjectURL(link.href);
		})
		.catch((error) => {
			enqueueSnackbar(handleAxiosErrors(error, t('Failed!')), {
				variant: 'warning',
				autoHideDuration: 3000,
			})
		})
	}
	
	return (
		<Button
			startIcon={<FileDownloadIcon/>}
			size="small"
			variant={'text'}
			onClick={handleExportExcel}
		>
			{t('Export')}
		</Button>
	)
}

export default ExportExcelFromUrl
